import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=fbcd2462&"
import script from "@/controllers/admin/textbook/Add?v=2.1?vue&type=script&lang=ts&"
export * from "@/controllers/admin/textbook/Add?v=2.1?vue&type=script&lang=ts&"
import style0 from "@/assets/css/backend.css?v=2.2?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports